import * as React from 'react';
const contextKey = Symbol.for('wayste-client');
export function getWaysteContext() {
    let context = React.createContext[contextKey];
    if (!context) {
        Object.defineProperty(React.createContext, contextKey, {
            value: (context = React.createContext({})),
            enumerable: false,
            writable: false,
            configurable: true,
        });
        context.displayName = 'WaysteContext';
    }
    return context;
}
export { getWaysteContext as resetWaysteContext };
//# sourceMappingURL=WaysteContext.js.map